var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBranch3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.6 54.2",
    style: {
      enableBackground: "new 0 0 52.6 54.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ABABAB;}\n\t.st1{fill:#009D63;}\n\t.st2{fill:#004597;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,53.2c-6.4,0-12.8,0-19.2,0c-1.5,0-2.3-1-2.3-2.3c0-8.5,0-17,0-25.4c0-0.9,0.3-1.6,1.1-2.1 c6.4-4.2,12.7-8.4,19-12.6c0.9-0.6,1.7-0.6,2.6,0C34,15,40.3,19.2,46.7,23.4c0.8,0.5,1.1,1.1,1.1,2c0,8.5,0,17.1,0,25.6 c0,1.4-0.7,2.1-2.2,2.1C39.2,53.2,32.7,53.2,26.3,53.2z M26.3,49.4c5.6,0,11.2,0,16.8,0c0.8,0,0.8,0,0.8-0.8c0-7.3,0-14.5,0-21.8 c0-0.5-0.1-0.8-0.6-1c-5.5-3.6-11-7.3-16.5-10.9c-0.4-0.3-0.7-0.3-1.1,0c-5.5,3.7-11,7.3-16.5,10.9c-0.4,0.3-0.6,0.6-0.6,1 c0,7.3,0,14.5,0,21.8c0,0.8,0,0.8,0.8,0.8C15.1,49.4,20.7,49.4,26.3,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,7.1c0.3,0,0.4-0.2,0.6-0.3c2.7-1.8,5.4-3.6,8.1-5.4c1.1-0.7,1.7-0.7,2.8,0C35.5,6.6,43.3,11.8,51.1,17 c1.1,0.7,1.4,1.7,1,2.6c-0.5,1.1-1.8,1.5-2.8,0.8c-0.8-0.5-1.6-1-2.3-1.5c-6.7-4.4-13.4-8.9-20-13.3c-0.5-0.3-0.8-0.3-1.3,0 c-7.4,4.9-14.7,9.8-22.1,14.7c-1,0.7-2.1,0.6-2.7-0.2c-0.8-0.9-0.6-2.2,0.5-3c2.7-1.8,5.4-3.6,8.1-5.4c0.8-0.5,1.6-1.1,2.4-1.6 c0.4-0.2,0.5-0.5,0.5-0.9c0-1.9,0-3.8,0-5.8c0-0.3,0-0.6,0.1-0.9c0.2-1.1,1-1.7,2.1-1.7c1,0.1,1.7,0.9,1.7,1.9 C16.2,4.3,16.2,5.7,16.2,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,26.5c0,0.5-0.2,0.9-0.5,1.2c-2.5,2.8-5,5.7-7.5,8.5c-1,1.1-2.2,1-3.1-0.1c-0.7-0.8-0.7-0.8-1.4,0 c-0.7,0.8-1.3,1.6-2,2.4c-1.1,1.3-2.3,1.3-3.4,0c-1-1.2-2-2.5-3-3.7c-0.8-0.9-0.7-2.2,0.1-2.9c0.8-0.7,2-0.6,2.8,0.4 c0.5,0.6,1,1.2,1.4,1.8c0.3,0.4,0.5,0.4,0.7,0c0.7-0.9,1.5-1.8,2.2-2.8c1.1-1.3,2.4-1.3,3.5,0c0.6,0.8,0.6,0.8,1.3,0 c1.7-2,3.5-3.9,5.2-5.9c0.6-0.6,1.2-1.1,2.1-0.8C37.9,24.8,38.5,25.5,38.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.2,45.5c-3.3,0-6.7,0-10,0c-1.3,0-2.1-0.8-2.1-2.1c0-0.8,0.6-1.5,1.3-1.7c0.4-0.1,0.7-0.1,1.1-0.1 c6.5,0,13,0,19.4,0c0.2,0,0.4,0,0.6,0c1.1,0.1,1.8,1,1.8,2.1c0,1-0.9,1.8-2,1.8c-1.5,0-3.1,0-4.6,0C30,45.5,28.1,45.5,26.2,45.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBranch3);
export default __webpack_public_path__ + "static/media/icon-branch-3.0d673b9705bff1cd348ec9672c5246c9.svg";
export { ForwardRef as ReactComponent };